<template>
  <div class="delGroupingDialog">
    <el-dialog
      title="退组"
      :visible.sync="open"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="true"
    >
      <div class="delGrouping-box">
        <div class="title-box">
          需将&nbsp;<span>A组临床</span>&nbsp;患者数据交接给其他分组后，才可退组
        </div>
        <div class="form-box">
          <el-form :model="form" :rules="rules" ref="ruleFormRef">
            <el-form-item label="选择交接成员" prop="newDocId">
              <el-select style="width: 320px;" v-model="form.newDocId" clearable placeholder="请选择交接成员">
                <el-option v-for="item in leaderList"
                           :key="item.docId"
                           :label="item.docName"
                           :value="item.docId" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="btn-box">
        <el-button @click="delClick" class="btn" type="primary"
          >交接并删除</el-button
        >
        <el-button @click="handleClose(Cancel)" class="btn">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "withdrawDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    doctorID: {
      type: String,
      default: () => ""
    },
    groupId: {
      type: String,
      default: () => ""
    },
    leaderList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      form: {
        newDocId: "",
      },
      rules: {
        newDocId: [
          {
            required: true,
            message: "请选择交接成员",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    open: {
      get() {
        console.log(`withdraw`);
        
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    delClick() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.confirmApi();
        }
      });
    },
    async confirmApi() {
      try{
        const res = await this.$post("group/exitGroup", {
          ...this.form,
          docId: this.doctorID,
          groupId: this.groupId,
          type: 0,
        })
        if (!res) return false;
        // eslint-disable-next-line no-unused-vars
        const { data } = res;
        this.$emit("confirm");
        this.open = false;
      }catch (e) {
        console.error(e);
      }
    },
    handleClose(done) {
      this.$refs.ruleFormRef.resetFields();
      done()
    },
    Cancel() {
      this.open = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.delGroupingDialog {
  .btn-box {
    width: 100%;
    border-top: 1px solid #ebecf0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 15px;
    padding-top: 25px;
    .btn {
      width: 90px;
      height: 36px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .delGrouping-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 30px;
    .title-box {
      font-size: 16px;
      span {
        font-weight: 700;
      }
    }
    .form-box {
      width: 100%;
      justify-content: center;
      align-content: center;
      padding-left: 68px;
    }
  }
}
::v-deep .el-dialog__header {
  background-color: #1a7cf2;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
::v-deep .el-form-item__error {
  left:24%
}


</style>
<script setup>
</script>
